import {Pipe, PipeTransform} from '@angular/core';
import {
	FundExecutionRowInterface,
	FundOpenPositionsRowInterface,
	FundOrderReportInterface,
	FundOrderReportModel,
} from '@spa/api';
import {Product} from 'src/app/pages/portal/services';

import {Language} from '../language';
import {LanguageService} from '../language.service';

type ProductNameType = Product
	| FundExecutionRowInterface
	| FundOpenPositionsRowInterface
	| FundOrderReportInterface
	| FundOrderReportModel;

@Pipe({
	name: 'productName'
})
export class ProductNamePipe implements PipeTransform {
	constructor(private languageService: LanguageService) {
	}

	transform(model?: ProductNameType): string {
		if (!model) {
			return '';
		}

		const isBulgarian = this.languageService.getCurrentLanguage() === Language.Bulgarian;

		if (model instanceof Product) {
			return isBulgarian
				? model.nameBG || model.name
				: model.name;
		}

		return isBulgarian
			? model.productNameBG || model.productName
			: model.productName;
	}
}
